import type { ScenariaPlan } from "src/model/model";

const serializePlanToScenarioMarkdown = (plan: ScenariaPlan): string => {
  const blocks = (plan.sceneOutline || []).map((scene, idx) => {
    const interactionLines = (scene.interactions || [])
      .map((inter) => `- ${inter.type}: ${inter.intent || ""}`.trimEnd())
      .join("\n");
    const lines = [
      `### Scène n° ${idx + 1}: ${scene.title || ""}`.trim(),
      `#### Média: ${scene.mediaType || "image360"}`,
    ];
    if (interactionLines) lines.push(interactionLines);
    return lines.join("\n");
  });
  return blocks.join("\n\n");
};

export default serializePlanToScenarioMarkdown;
